<template>
    <div class="comment-body">
        <p class="main-comment" v-if="body.length > 150">
            {{ body.substring(0, 150) }}
            <button class="review-comment-expand" :id="`more-btn-${_uid}`" @click="open()">
                More +
            </button>
        </p>
        <p class="full-comment">
            {{ body }}
            <button v-if="body.length > 150" class="review-comment-shrink" :id="`less-btn-${_uid}`" @click="close()">
                Less -
            </button>
        </p>
    </div>
</template>
<script>
export default {

    props:['review'],

    data(){
        return {
            body: this.review.body ? this.review.body : '',
            moreButton : null,
            lessButton : null,
        }
    },

    mounted(){
        this.moreButton = $(`#more-btn-${this._uid}`)
        this.lessButton = $(`#less-btn-${this._uid}`)
    },

    methods:{
        open() {
            var startHeight = this.moreButton.parents('.main-comment').outerHeight()
            var endHeight = this.moreButton.parents('.comment-body').find('.full-comment').show().get(0).scrollHeight
            this.moreButton.parents('.main-comment')
                .hide()
                .next()
                .height(startHeight)
                .show()
                .height(endHeight)
        },

        close(){
            var startHeight = this.lessButton.parents('.full-comment').siblings('.main-comment').show().get(0).scrollHeight
            this.lessButton.parents('.full-comment').siblings('.main-comment').hide()
            this.lessButton.parents('.full-comment').height(startHeight)
            this.lessButton.parents('.full-comment').hide().siblings('.main-comment').show()
        }
    }
}
</script>
